<script setup>
import { messages } from './store.js'
</script>

<template>
  <div class="space-y-8">
    <f-alert
      v-model="messages.info.length"
      positive
    >
      <p
        v-for="m in messages.info"
        class="text-14"
      >
        {{ m }}
      </p>
    </f-alert>
    <f-alert
      v-model="messages.warning.length"
      warning
    >
      <p
        v-for="m in messages.warning"
        class="text-14"
      >
        {{ m }}
      </p>
    </f-alert>
  </div>
</template>
